module.exports = __webpack_public_path__ + "img/cover.60bb66e3.jpg";